module.exports = __webpack_public_path__ + "static/rv-48abbbdf1a2b74560d7b0d61d3e95e9f.png";